import { Component } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    PriceService
} from '@varsity/services';
import { BaseComponent } from '../BaseComponent';
import { PopoverController, ToastController, NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the ProgressBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'progress-bar',
    templateUrl: 'progress-bar.html'
})
export class ProgressBarComponent extends BaseComponent {
    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "ProgressBarComponent"
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/progress-bar/progress-bar.ts